import React from 'react'
import { formatNumber } from 'core/lib'

function Product({ product }) {
	const qty = product.quantity > 1 ? `${product.quantity} x ` : ''
	return <p className="product">
		<span className='name' dangerouslySetInnerHTML={{ __html: `${qty}${product.html_title}` }}></span>
		<span className="amount">{formatNumber(product.quantity * product.price)} €</span>
		<br/>
		{product.options && product.options.length > 0 && <small>
			{product.options.map((option, o) => <span key={o} style={{ display: 'block' }}>
				{option.name}: {option.values.map(value => value.value).join(', ')}
			</span>)}
		</small>}
	</p>
}

export default Product
